<template>
    <div class="header">
        <!-- Duplicate div.gradient for stronger white -->
        <!-- <div v-if="!isNavSolid" class="gradient"></div> -->
        <!-- <div v-if="!isNavSolid" class="gradient"></div> -->
        <div class="header-one" :class="{'header-one-solid': isNavSolid}">
            <ul class="header-one-nav">
                <li class="header-one-nav-item">
                    <router-link to="/news" class="header-one-nav-a">NEWS</router-link>
                </li>
                <li class="header-one-nav-item">
                    <a @click="goTo('about')" @mouseout="closeDropdownOne()" @mouseover="toggleDropdownOne($event, 'about')" class="header-one-nav-a">ABOUT US</a>
                </li>
                <li class="header-one-nav-item">
                    <a @click="goTo('investors')" @mouseout="closeDropdownOne()" @mouseover="toggleDropdownOne($event, 'investors')" class="header-one-nav-a">INVESTORS</a>
                </li>
                <li class="header-one-nav-item">
                    <a @click="goTo('careers')" @mouseout="closeDropdownOne()" @mouseover="toggleDropdownOne($event, 'careers')"  class="header-one-nav-a">CAREERS</a>
                </li>
                <li class="header-one-nav-item">
                    <a @click="goTo('dc')" @mouseout="closeDropdownOne()" @mouseover="toggleDropdownOne($event, 'dc')" class="header-one-nav-a">DOWNLOAD CENTER</a>
                </li>
            </ul>
            <transition name="show">
              <div class="dropdown-wrapper dropdown-one" v-show="isDropdownOneVisible" ref="dropdownOne" @mouseover="closeDropdownOneIdle = false" @mouseout="closeDropdownOne()">
                <div class="dropdown" key="dropdown-about">
                  <div class="dropdown-header">
                    <div v-if="dropdownOneContent === 'news'">
                      <router-link class="dropdown-header-link" to="/news/1">Latest News</router-link>
                      <router-link class="dropdown-header-link" to="/news/1">Medias about us</router-link>
                    </div>
                    <div v-if="dropdownOneContent === 'about'">
                      <router-link class="dropdown-header-link" to="/about-the-company/about-us">About us</router-link>
                      <router-link class="dropdown-header-link" to="/about-the-company/mission-and-values">Mission and values</router-link>
                      <router-link class="dropdown-header-link" to="/about-the-company/key-figures">Key figures</router-link>
                      <router-link class="dropdown-header-link" to="/about-the-company/r-and-d">R&amp;D</router-link>
                      <router-link class="dropdown-header-link" to="/about-the-company/rolling-plant">Rolling plant</router-link>
                      <router-link class="dropdown-header-link" to="/about-the-company/extrusion-plant">Extrusion plant</router-link>
                      <router-link class="dropdown-header-link" to="/about-the-company/automotive-facility">Automotive facility</router-link>
                      <router-link class="dropdown-header-link" to="/about-the-company/timeline">Timeline</router-link>
                    </div>
                    <div v-else-if="dropdownOneContent === 'investors'">
                      <router-link class="dropdown-header-link" to="/investors/management">Management</router-link>
                      <router-link class="dropdown-header-link" to="/investors/financial-statements">Financial statements</router-link>
                      <router-link class="dropdown-header-link" to="/investors/general-meetings">General meetings</router-link>
                      <router-link class="dropdown-header-link" to="/investors/calendar">Calendar for Investors</router-link>
                      <router-link class="dropdown-header-link" to="/investors/shares">Shares</router-link>
                      <!-- <router-link class="dropdown-header-link" to="/investors/presentations">Presentations</router-link> -->
                    </div>
                    <div v-else-if="dropdownOneContent === 'careers'">
                      <router-link class="dropdown-header-link" to="/careers/career">A career in Alcomet</router-link>
                      <router-link class="dropdown-header-link" to="/careers/open-positions">Open positions</router-link>
                      <router-link class="dropdown-header-link" to="/careers/internships">Internships</router-link>
                      <!-- <router-link class="dropdown-header-link" to="/careers/application-form">Application form</router-link> -->
                    </div>
                    <div v-else-if="dropdownOneContent === 'dc'">
                      <router-link class="dropdown-header-link" to="/download-center/catalogues">Catalogues</router-link>
                      <router-link class="dropdown-header-link" to="/download-center/certificates">Certificates</router-link>
                      <!-- <router-link class="dropdown-header-link" to="/download-center/reports">Reports</router-link> -->
                      <router-link class="dropdown-header-link" to="/download-center/presentations">Presentations</router-link>
                      <router-link class="dropdown-header-link" to="/download-center/generalterms">General terms and conditions for sale</router-link>
                    </div>
                    <div v-else-if="dropdownOneContent === 'share'">
                      <a target="_blank" href="https://www.linkedin.com/company/alcomet-ad" class="dropdown-header-link link-small link-social"><span class="alcomet">C</span> LinkedIn</a>
                      <a target="_blank" href="https://www.facebook.com/alcomet.ad" class="dropdown-header-link link-small link-social"><span class="alcomet">D</span> Facebook</a>
                      <a target="_blank" href="https://www.youtube.com/channel/UCPGrPxmthUjepLlI-lbMoCg?sub_confirmation=1" class="dropdown-header-link link-small link-social"><span class="alcomet">E</span> Youtube</a>
                      <a target="_blank" href="https://www.instagram.com/alcometad/" class="dropdown-header-link link-small link-social"><span class="alcomet">B</span> Instagram</a>
                    </div>
                    <div v-else-if="dropdownOneContent === 'lang'">
                      <a class="dropdown-header-link link-small" href="http://www.alcomet.bg">Български</a>
                      <a class="dropdown-header-link link-small" href="http://www.alcomet.eu">English</a>
                      <a class="dropdown-header-link link-small" href="http://www.alcomet.it">Italiano</a>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <div class="functional-buttons">
                <a class="social-btn" href="#">
                  <!-- <span class="alcomet strong">k</span> -->
                  <span @mouseout="closeDropdownOne()" @mouseover="toggleDropdownOne($event, 'share')" class="btn-blue-bold-text follow-us">FOLLOW US</span>
                  </a>
                <a class="social-btn" @click.prevent="goToSubscribe()" title="Subscribe to Alcomet Newsletter">
                  <span class="alcomet">P</span>
                  <span class="btn-blue-bold-text">SUBSCRIBE</span>
                </a>
                <a class="social-btn">
                  <span @mouseout="closeDropdownOne()" @mouseover="toggleDropdownOne($event, 'lang')" class="btn-blue-bold-text lang-arrow">EN</span>
                  <!-- <span class="alcomet strong">L</span> -->
                </a>
                <a href="#" class="social-btn" @click="isSearchActive = true">
                  <span class="alcomet strong">R</span>
                </a>
            </div>
        </div>
        <div class="header-two" :class="{'header-two-solid': isNavSolid, 'header-two-solid-home' : (!isNavSolid && this.$route.path === '/')}">
            <router-link class="logo" to="/">
                <img v-if="isNavSolid" src="/static/img/logo.png">
                <img v-else-if="!isMobileMenuOpened && !isNavSolid && this.$route.path !== '/'" src="/static/img/logo_white.png">
                <img v-else src="/static/img/logo.png">
            </router-link>
            <div class="mobile-menu-wrapper">
              <transition name="mobile-menu-toggle-transition">
                <div v-if="isMobileMenuOpened" class="mobile-search-toggle mobile-toggle-inverted" @click="isSearchActive = true">
                  <div class="mobile-search-toggle-inside mobile-toggle-inside-inverted">
                    <span class="alcomet strong">R</span>
                  </div>
                </div>
              </transition>
              <div class="mobile-menu-toggle" @click="toggleMobileMenu()" :class="{ 'mobile-toggle-inverted' : isMobileMenuOpened }">
                <div class="mobile-menu-toggle-inside" :class="{ 'mobile-toggle-inside-inverted' : isMobileMenuOpened }">
                  <span class="mobile-menu-line" :class="{ 'mobile-menu-line-active-1' : isMobileMenuOpened }"></span>
                  <span class="mobile-menu-line" :class="{ 'mobile-menu-line-active-2' : isMobileMenuOpened }"></span>
                  <span class="mobile-menu-line" :class="{ 'mobile-menu-line-active-3' : isMobileMenuOpened }"></span>
                </div>
              </div>
            </div>
            <ul class="header-two-nav" :class="{ 'header-two-nav-white-text' : !isNavSolid }">
                <li class="header-two-nav-item">
                    <router-link to="/" class="header-two-nav-a" active-class="header-two-nav-a-active">HOME</router-link>
                </li>
                <li class="header-two-nav-item">
                    <a @click="goTo('markets')" @mouseout="closeDropdownTwo()" @mouseover="toggleDropdownTwo($event, 'markets')" class="header-two-nav-a" active-class="header-two-nav-a-active">MARKETS</a>
                </li>
                <li class="header-two-nav-item">
                    <a @click="goTo('products')" @mouseout="closeDropdownTwo()" @mouseover="toggleDropdownTwo($event, 'products')" class="header-two-nav-a" active-class="header-two-nav-a-active">PRODUCTS</a>
                </li>
                <li class="header-two-nav-item">
                    <a @click="goTo('sustainability')" @mouseout="closeDropdownTwo()" @mouseover="toggleDropdownTwo($event, 'sustainability')" class="header-two-nav-a" active-class="header-two-nav-a-active">SUSTAINABILITY</a>
                </li>
                <li class="header-two-nav-item">
                    <router-link to="/contacts/sales-department" class="header-two-nav-a" active-class="header-two-nav-a-active">CONTACTS</router-link>
                </li>
                <transition name="show">
                  <div class="dropdown-wrapper dropdown-two" v-show="isDropdownTwoVisible" ref="dropdownTwo" @mouseover="closeDropdownTwoIdle = false" @mouseout="closeDropdownTwo()">
                    <div class="dropdown-content">
                        <div class="dropdown" key="dropdown-markets">
                          <div class="dropdown-header">
                            <div key="dh-1" v-if="dropdownTwoContent === 'markets'">
                              <router-link class="dropdown-header-link" to="/markets/building-and-architecture">Building &amp; Architecture</router-link>
                              <router-link class="dropdown-header-link" to="/markets/automotive">Automotive</router-link>
                              <router-link class="dropdown-header-link" to="/markets/transportation">Transportation</router-link>
                              <router-link class="dropdown-header-link" to="/markets/packaging">Packaging</router-link>
                              <router-link class="dropdown-header-link" to="/markets/distribution">Distribution</router-link>
                            </div>
                            <div key="dh-2" v-else-if="dropdownTwoContent === 'products'">
                              <router-link class="dropdown-header-link" to="/products/rolled-foils/household-foil">Rolled Products</router-link>
                              <router-link class="dropdown-header-link" to="/products/extruded/profiles-for-building-and-architecture">Extruded Products</router-link>
                            </div>
                            <div key="dh-3" v-else-if="dropdownTwoContent === 'sustainability'">
                              <router-link class="dropdown-header-link" to="/sustainability/environment">Environment & Recycling</router-link>
                              <router-link class="dropdown-header-link" to="/sustainability/health-and-safety">Health and safety</router-link>
                              <router-link class="dropdown-header-link" to="/sustainability/sustainability-reports">Sustainability reports</router-link>
                            </div>
                            <div key="dh-4" v-else-if="dropdownTwoContent === 'contacts'">
                              <router-link class="dropdown-header-link" to="/contacts/sales-department">Sales</router-link>
                              <router-link class="dropdown-header-link" to="/contacts/supply-chains">Supply chain</router-link>
                              <router-link class="dropdown-header-link" to="/contacts/other-contacts">Other contacts</router-link>
                            </div>
                          </div>
                          <!--
                          <div class="dropdown-footer"
                          v-if="dropdownTwoContent === 'markets' || dropdownTwoContent === 'sustainability' || dropdownTwoContent === 'contacts'">
                            <transition-group name="drop">
                              <router-link key="df-1" v-if="dropdownTwoContent === 'markets'" to="/markets/other-industries">Other industries</router-link>
                              <router-link key="df-3" v-else-if="dropdownTwoContent === 'sustainability'" to="/sustainability/responsibility">Responsibility</router-link>
                              <router-link key="df-4" v-else-if="dropdownTwoContent === 'contacts'" to="/contacts/factory-location">Location</router-link>
                            </transition-group>
                          </div>
                          -->
                          <div class="dropdown-footer"
                               v-if="dropdownTwoContent === 'sustainability' || dropdownTwoContent === 'contacts'">
                            <transition-group name="drop">
                              <router-link key="df-3" v-if="dropdownTwoContent === 'sustainability'" to="/sustainability/responsibility">Responsibility</router-link>
                              <router-link key="df-4" v-else-if="dropdownTwoContent === 'contacts'" to="/contacts/factory-location">Location</router-link>
                            </transition-group>
                          </div>
                        </div>
                    </div>
                  </div>
                </transition>
            </ul>
        </div>
        <transition name="mobile-menu-transition">
          <div class="mobile-menu" v-if="isMobileMenuOpened">
            <ul class="mobile-menu-main-items">
              <li :class="{ 'mobile-menu-main-item-active' : mobileMenu.home }">
                <router-link class="mobile-menu-home" to="/">HOME</router-link>
                <!-- <span @click="mobileMenuItemSelected('home')">HOME</span> -->
                <!-- <ul class="mobile-menu-sub-items" :class="{ 'mobile-menu-sub-items-active' : mobileMenu.home }">
                  <li>
                    <router-link class="mobile-menu-sub-link" to="/">HOME</router-link>
                  </li>
                </ul> -->
              </li>
              <li :class="{ 'mobile-menu-main-item-active' : mobileMenu.products }">
                <span @click="mobileMenuItemSelected('products')">PRODUCTS</span>
                <ul class="mobile-menu-sub-items" :class="{ 'mobile-menu-sub-items-active' : mobileMenu.products }">
                  <li><router-link class="mobile-menu-sub-link" to="/products">PRODUCTS</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/products/rolled-foils/household-foil">ROLLED PRODUCTS</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/products/extruded/profiles-for-building-and-architecture">EXTRUDED PRODUCTS</router-link></li>
                </ul>
              </li>
              <li :class="{ 'mobile-menu-main-item-active' : mobileMenu.contacts }">
                <span @click="mobileMenuItemSelected('contacts')">CONTACTS</span>
                <ul class="mobile-menu-sub-items" :class="{ 'mobile-menu-sub-items-active' : mobileMenu.contacts }">
                  <li><router-link class="mobile-menu-sub-link" to="/contacts/sales-department">SALES DEPARTMENT</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/contacts/supply-chains">SUPPLY CHAIN</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/contacts/other-contacts">OTHER CONTACTS</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/contacts/factory-location">FACTORY LOCATION</router-link></li>
                </ul>
              </li>
              <li :class="{ 'mobile-menu-main-item-active' : mobileMenu.markets }">
                <span @click="mobileMenuItemSelected('markets')">MARKETS</span>
                <ul class="mobile-menu-sub-items" :class="{ 'mobile-menu-sub-items-active' : mobileMenu.markets }">
                  <li><router-link class="mobile-menu-sub-link" to="/markets/building-and-architecture">BUILDING &amp; ARCHITECTURE</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/markets/automotive">AUTOMOTIVE</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/markets/transportation">TRANSPORTATION</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/markets/packaging">PACKAGING</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/markets/distribution">DISTRIBUTION</router-link></li>
                  <!-- <li><router-link class="mobile-menu-sub-link" to="/markets/other-industries">OTHER INDUSTRIES</router-link></li> -->
                </ul>
              </li>
              <li :class="{ 'mobile-menu-main-item-active' : mobileMenu.sustainability }">
                <span @click="mobileMenuItemSelected('sustainability')">SUSTAINABILITY</span>
                <ul class="mobile-menu-sub-items" :class="{ 'mobile-menu-sub-items-active' : mobileMenu.sustainability }">
                  <li><router-link class="mobile-menu-sub-link" to="/sustainability/environment">ENVIRONMENT & RECYCLING</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/sustainability/health-and-safety">HEALTH AND SAFETY</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/sustainability/sustainability-reports">SUSTAINABILITY REPORTS</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/sustainability/responsibility">RESPONSIBILITY</router-link></li>
                </ul>
              </li>
              <li :class="{ 'mobile-menu-main-item-active' : mobileMenu.news }">
                <span @click="mobileMenuItemSelected('news')">NEWS</span>
                <ul class="mobile-menu-sub-items" :class="{ 'mobile-menu-sub-items-active' : mobileMenu.news }">
                  <li><router-link class="mobile-menu-sub-link" to="/news">NEWS</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/news?medias=true">MEDIAS ABOUT US</router-link></li>
                </ul>
              </li>
              <li :class="{ 'mobile-menu-main-item-active' : mobileMenu.about }">
                <span @click="mobileMenuItemSelected('about')">ABOUT US</span>
                <ul class="mobile-menu-sub-items" :class="{ 'mobile-menu-sub-items-active' : mobileMenu.about }">
                  <li><router-link class="mobile-menu-sub-link" to="/about-the-company/about-us">ABOUT US</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/about-the-company/mission-and-values">MISSION AND VALUES</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/about-the-company/key-figures">KEY FIGURES</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/about-the-company/r-and-d">R&amp;D</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/about-the-company/rolling-plant">ROLLING PLANT</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/about-the-company/extrusion-plant">EXTRUSION PLANT</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/about-the-company/timeline">TIMELINE</router-link></li>
                </ul>
              </li>
              <li :class="{ 'mobile-menu-main-item-active' : mobileMenu.investors }">
                <span @click="mobileMenuItemSelected('investors')">INVESTORS</span>
                <ul class="mobile-menu-sub-items" :class="{ 'mobile-menu-sub-items-active' : mobileMenu.investors }">
                  <li><router-link class="mobile-menu-sub-link" to="/investors/management">MANAGEMENT</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/investors/financial-statements">FINANCIAL STATEMENTS</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/investors/general-meetings">GENERAL MEETINGS</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/investors/calendar">CALENDAR FOR INVESTORS</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/investors/shares">SHARES</router-link></li>
                  <!-- <li><router-link class="mobile-menu-sub-link" to="/investors/presentations">PRESENTATIONS</router-link></li> -->
                </ul>
              </li>
              <li :class="{ 'mobile-menu-main-item-active' : mobileMenu.careers }">
                <span @click="mobileMenuItemSelected('careers')">CAREERS</span>
                <ul class="mobile-menu-sub-items" :class="{ 'mobile-menu-sub-items-active' : mobileMenu.careers }">
                  <li><router-link class="mobile-menu-sub-link" to="/careers/career">A CAREER IN ALCOMET</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/careers/open-positions">OPEN POSITIONS</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/careers/internships">INTERNSHIPS</router-link></li>
                  <!-- <li><router-link class="mobile-menu-sub-link" to="/careers/application-form">APPLICATION FORM</router-link></li> -->
                </ul>
              </li>
              <li :class="{ 'mobile-menu-main-item-active' : mobileMenu.download }">
                <span @click="mobileMenuItemSelected('download')">DOWNLOAD CENTER</span>
                <ul class="mobile-menu-sub-items" :class="{ 'mobile-menu-sub-items-active' : mobileMenu.download }">
                  <li><router-link class="mobile-menu-sub-link" to="/download-center/catalogues">CATALOGUES</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/download-center/certificates">CERTIFICATES</router-link></li>
                  <!-- <li><router-link class="mobile-menu-sub-link" to="/download-center/reports">REPORTS</router-link></li> -->
                  <li><router-link class="mobile-menu-sub-link" to="/download-center/presentations">PRESENTATIONS</router-link></li>
                  <li><router-link class="mobile-menu-sub-link" to="/download-center/generalterms">GENERAL TERMS AND CONDITIONS FOR SALES</router-link></li>
                </ul>
              </li>
            </ul>
            <div class="mobile-menu-footer">
              <a href="#" target="_blank" class="alcomet mobile-menu-footer-item">C</a>
              <a href="#" target="_blank" class="alcomet mobile-menu-footer-item">D</a>
              <a href="#" target="_blank" class="alcomet mobile-menu-footer-item">E</a>
              <a href="#" target="_blank" class="alcomet mobile-menu-footer-item">B</a>
              <a href="#" target="_blank" class="alcomet mobile-menu-footer-item">P</a>
            </div>
          </div>
        </transition>
        <transition name="show">
          <app-search v-if="isSearchActive"></app-search>
        </transition>
    </div>
</template>

<script>
import Search from "./Search";
export default {
  components: {
    appSearch: Search
  },
  data() {
    return {
      isNavSolid: false,
      isDropdownOneVisible: false,
      isDropdownTwoVisible: false,
      isScrollingDownwards: false,
      isMobileMenuOpened: false,
      lastScrollPosition: 0,
      dropdownOneContent: "share",
      dropdownTwoContent: "markets",
      closeDropdownOneIdle: false,
      closeDropdownTwoIdle: false,
      isSearchActive: false,
      mobileMenu: {
        home: false,
        about: false,
        news: false,
        products: false,
        contacts: false,
        markets: false,
        sustainability: false,
        investors: false,
        careers: false,
        download: false
      }
    };
  },
  watch: {
    $route(to, from) {
      this.isDropdownOneVisible = false;
      this.isDropdownTwoVisible = false;
      this.isMobileMenuOpened = false;
      for (let el in this.mobileMenu) {
        this.mobileMenu[el] = false;
      }
    }
  },
  methods: {
    goTo(where) {
      if (where === "products") {
        this.$router.push({
          name: "ProductsMain"
        });
      } else if (where === "about") {
        this.$router.push({
          name: "AboutPage",
          params: {
            page: "about-us"
          }
        });
      } else if (where === "investors") {
        this.$router.push({
          name: "Investors",
          params: {
            page: "management"
          }
        });
      } else if (where === "careers") {
        this.$router.push({
          name: "Careers",
          params: {
            page: "career"
          }
        });
      } else if (where === "dc") {
        this.$router.push({
          name: "DownloadCenter",
          params: {
            page: "catalogues"
          }
        });
      } else if (where === "markets") {
        this.$router.push({
          name: "MarketsPage",
          params: {
            page: "packaging"
          }
        });
      } else if (where === "sustainability") {
        this.$router.push({
          name: "Sustainability",
          params: {
            page: "environment"
          }
        });
      }
    },
    toggleDropdownOne(ev, cont) {
      this.isDropdownTwoVisible = false;
      this.closeDropdownTwoIdle = false;

      this.closeDropdownOneIdle = false;
      this.isDropdownOneVisible = true;
      this.dropdownOneContent = cont;

      this.$refs.dropdownOne.style.left =
        ev.target.offsetLeft + ev.target.offsetWidth / 2 + "px";
    },
    closeDropdownOne() {
      this.closeDropdownOneIdle = true;
      setTimeout(() => {
        if (this.closeDropdownOneIdle) this.isDropdownOneVisible = false;
        this.closeDropdownOneIdle = false;
      }, 2000);
    },
    toggleDropdownTwo(ev, cont) {
      this.isDropdownOneVisible = false;
      this.closeDropdownOneIdle = false;

      this.closeDropdownTwoIdle = false;
      this.isDropdownTwoVisible = true;
      this.dropdownTwoContent = cont;

      this.$refs.dropdownTwo.style.left =
        ev.target.offsetLeft + ev.target.offsetWidth / 2 + "px";
    },
    closeDropdownTwo() {
      this.closeDropdownTwoIdle = true;
      setTimeout(() => {
        if (this.closeDropdownTwoIdle) this.isDropdownTwoVisible = false;
        this.closeDropdownTwoIdle = false;
      }, 2000);
    },
    goToSubscribe() {
      const subscribe = document.getElementById("subscribeInput");
      if (subscribe) {
        subscribe.scrollIntoView({ behavior: "smooth" });
        setTimeout(() => {
          subscribe.focus();
        }, 1000);
      }
    },
    toggleMobileMenu() {
      this.isMobileMenuOpened =
        this.isMobileMenuOpened === false ? true : false;
    },
    mobileMenuItemSelected(item) {
      if (this.mobileMenu[item]) {
        this.mobileMenu[item] = false;
      } else {
        for (let el in this.mobileMenu) {
          if (el == item) {
            this.mobileMenu[item] = true;
          } else {
            this.mobileMenu[el] = false;
          }
        }
      }
    }
  },
  mounted() {
    document.addEventListener("scroll", () => {
      this.isNavSolid = window.pageYOffset < 1 ? false : true;
      if (
        this.lastScrollPosition > window.pageYOffset ||
        window.pageYOffset == 0
      ) {
        this.isScrollingDownwards = false;
      } else {
        this.isScrollingDownwards = true;
      }
      this.lastScrollPosition = window.pageYOffset;
    });
    // Watch for search closed event from Search.vue
    this.$eventHub.$on("search-closed", () => {
      this.isSearchActive = false;
    });
  },
  destroyed() {
    this.$eventHub.$off("search-closed");
  }
};
</script>

<style scoped>
.mobile-menu-toggle,
.mobile-menu {
  display: none;
}
.header {
  /* background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=0 ); */
  font-size: 14px;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
}

.header-one {
  align-items: center;
  background: #fff;
  display: flex;
  justify-content: space-between;
  height: 40px;
  overflow: hidden;
  padding: 0 40px;
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -ms-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
  width: 100%;
}

.header-one-solid {
  /* background: #fff; */
  height: 30px;
}

.header-one-nav-a {
  color: #004787;
  font-weight: 700;
  margin-right: 42px;
  position: relative;
}

.header-one-nav-item:last-child .header-one-nav-a {
  margin-right: 0;
}

.functional-buttons {
  align-items: center;
  display: flex;
  justify-content: center;
}

.social-btn {
  /* font-size: 18px; */
  align-items: center;
  display: flex;
  margin: 0 16px;
}

.subscribe-btn,
.lang-btn {
  align-items: center;
  display: inline-flex;
  /* display: flex; */
  justify-content: center;
}

.subscribe-btn {
  margin: 0 40px 0 20px;
}

.lang-btn {
  margin-right: 30px;
}

.btn-blue-bold-text {
  color: #004787;
  font-weight: 900;
  margin-left: 7px;
  margin-right: 11px;
  position: relative;
}
.follow-us::before {
  content: "k";
  font-family: "alcomet";
  position: absolute;
  left: -20px;
  bottom: 0;
}
.lang-arrow::before {
  content: "L";
  font-family: "alcomet";
  position: absolute;
  right: -20px;
  bottom: 0;
}
.header-two {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.9);
  background-color: transparent;
  color: #fff;
  display: flex;
  justify-content: space-between;
  height: 70px;
  padding: 1.5vh 40px;
  position: relative;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  width: 100%;
}
/* .header-two::before {
  background: -moz-linear-gradient(
    top,
    rgba(239, 243, 247, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(239, 243, 247, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(239, 243, 247, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#eff3f7', endColorstr='#00000000',GradientType=0 );
  content: "";
  height: 20px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
} */
.header-two-solid {
  background-color: rgba(255, 255, 255, 1);
  height: 60px;
}
.header-two-nav-white-text .header-two-nav-item .header-two-nav-a {
  color: #fff !important;
}
.header-two-alone {
  background-color: #fff;
  height: 60px;
}
.logo {
  position: relative;
  z-index: 1;
}
.logo img {
  height: auto;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  width: 180px;
}
.header-two-nav-a {
  color: #004787;
  /*color: #fff;*/
  font-weight: 900;
  margin: 0 22px;
  position: relative;
  -webkit-transition: all 0.4s ease-in-out;
  -moz-transition: all 0.4s ease-in-out;
  -ms-transition: all 0.4s ease-in-out;
  -o-transition: all 0.4s ease-in-out;
  transition: all 0.4s ease-in-out;
}
.header-two-nav {
  position: relative;
  display: flex;
}
.search-btn,
.social-btn {
  margin-right: 20px;
}

.gradient {
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#00ffffff',GradientType=0 );
  height: 140px;
  left: 0;
  position: fixed;
  top: 0;
  z-index: -1;
  width: 100%;
}
.hide-header-one {
  height: 0;
}
.dropdown-wrapper {
  background-color: #fff;
  border-radius: 5px;
  -webkit-box-shadow: 0px 0px 100px -25px rgba(0, 4, 120, 1);
  -moz-box-shadow: 0px 0px 100px -25px rgba(0, 4, 120, 1);
  box-shadow: 0px 0px 100px -25px rgba(0, 4, 120, 1);
  left: 0;
  position: absolute;
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
  transform: translateX(-50%);
  z-index: 2;
}
.dropdown-one {
  top: 40px;
}
.dropdown-two {
  top: 30px;
}
.dropdown-wrapper::before {
  border-bottom: 10px solid #fff;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  content: "";
  height: 0;
  top: -9px;
  left: calc(50% - 10px);
  position: absolute;
  width: 0;
}
.dropdown,
.dropdown-content {
  overflow: hidden;
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
  position: relative;
}
.dropdown-header {
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
  padding: 10px 0;
}
.dropdown-header-link {
  align-items: center;
  display: flex;
  padding: 15px 30px;
}
.link-small {
  padding: 10px 30px;
}
.link-social span {
  font-size: 16px;
  margin-right: 8px;
}
.dropdown-header-link:hover {
  background-color: #f1f4f8;
}

.dropdown-footer {
  background-color: #f1f4f8;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  overflow: hidden;
  padding: 10px 0;
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -ms-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
.dropdown-footer a {
  display: block;
  font-weight: 700;
  padding: 10px 30px;
  text-align: center;
}
.show-enter-active,
.show-leave-active {
  transition: all 0.3s;
}
.show-enter,
.show-leave-to {
  opacity: 0;
  transform-style: preserve-3d;
  transform: rotateX(-15deg) translateX(-50%);
  transform-origin: 0 0;
}
/* RESPONSIVE */
@media screen and (max-width: 1600px) {
  .header-one,
  .header-two {
    padding: 0 40px;
  }
}
@media screen and (max-width: 1440px) {
  .header-one-nav-a {
    margin-right: 40px;
  }
}
@media screen and (max-width: 1280px) {
  .header {
    font-size: 12px;
  }
}
/* MOBILE */
@media screen and (max-width: 1000px) {
  .header-one,
  .header-two-nav {
    display: none;
  }
  .header-two {
    height: 90px;
    padding: 0 20px;
  }
  .header-two-solid-home,
  .header-two-solid {
    background-color: rgba(255, 255, 255, 0.85);
  }

  .logo img {
    width: 170px;
  }
  .mobile-menu-wrapper {
    display: flex;
    position: relative;
    z-index: 1;
  }
  .mobile-search-toggle,
  .mobile-menu-toggle {
    align-items: center;
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#2ea5d8+0,004786+15,004786+24,2ea5d8+40,2593c8+50,0e639e+65,004786+75,004786+85,2ea5d8+100 */
    background: rgb(46, 165, 216); /* Old browsers */
    background: -moz-linear-gradient(
      top,
      rgba(46, 165, 216, 1) 0%,
      rgba(0, 71, 134, 1) 15%,
      rgba(0, 71, 134, 1) 24%,
      rgba(46, 165, 216, 1) 40%,
      rgba(37, 147, 200, 1) 50%,
      rgba(14, 99, 158, 1) 65%,
      rgba(0, 71, 134, 1) 75%,
      rgba(0, 71, 134, 1) 85%,
      rgba(46, 165, 216, 1) 100%
    ); /* FF3.6-15 */
    background: -webkit-linear-gradient(
      top,
      rgba(46, 165, 216, 1) 0%,
      rgba(0, 71, 134, 1) 15%,
      rgba(0, 71, 134, 1) 24%,
      rgba(46, 165, 216, 1) 40%,
      rgba(37, 147, 200, 1) 50%,
      rgba(14, 99, 158, 1) 65%,
      rgba(0, 71, 134, 1) 75%,
      rgba(0, 71, 134, 1) 85%,
      rgba(46, 165, 216, 1) 100%
    ); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(
      to bottom,
      rgba(46, 165, 216, 1) 0%,
      rgba(0, 71, 134, 1) 15%,
      rgba(0, 71, 134, 1) 24%,
      rgba(46, 165, 216, 1) 40%,
      rgba(37, 147, 200, 1) 50%,
      rgba(14, 99, 158, 1) 65%,
      rgba(0, 71, 134, 1) 75%,
      rgba(0, 71, 134, 1) 85%,
      rgba(46, 165, 216, 1) 100%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2ea5d8', endColorstr='#2ea5d8',GradientType=0 ); /* IE6-9 */
    border-radius: 50%;
    border: 1px solid transparent;
    cursor: pointer;
    display: flex;
    height: 50px;
    justify-content: center;
    width: 50px;
  }
  .mobile-search-toggle {
    margin-right: 10px;
  }
  .mobile-search-toggle-inside,
  .mobile-menu-toggle-inside {
    background-color: #fff;
    align-items: center;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    height: 42px;
    justify-content: center;
    overflow: hidden;
    position: relative;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    width: 42px;
  }
  .mobile-search-toggle-inside > span {
    color: #fff;
    font-size: 17px;
    font-weight: 700;
  }
  .mobile-menu-line {
    background-color: #004785;
    display: inline-block;
    width: 18px;
    height: 2px;
    margin: 2px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .mobile-toggle-inverted {
    background: #fff;
    background-color: #fff;
    border: 1px solid #004785;
  }
  .mobile-toggle-inside-inverted {
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#2ea5d8+0,004786+15,004786+24,2ea5d8+40,2593c8+50,0e639e+65,004786+75,004786+85,2ea5d8+100 */
    background: rgb(46, 165, 216); /* Old browsers */
    background: -moz-linear-gradient(
      left,
      rgba(46, 165, 216, 1) 0%,
      rgba(0, 71, 134, 1) 15%,
      rgba(0, 71, 134, 1) 24%,
      rgba(46, 165, 216, 1) 40%,
      rgba(37, 147, 200, 1) 50%,
      rgba(14, 99, 158, 1) 65%,
      rgba(0, 71, 134, 1) 75%,
      rgba(0, 71, 134, 1) 85%,
      rgba(46, 165, 216, 1) 100%
    ); /* FF3.6-15 */
    background: -webkit-linear-gradient(
      left,
      rgba(46, 165, 216, 1) 0%,
      rgba(0, 71, 134, 1) 15%,
      rgba(0, 71, 134, 1) 24%,
      rgba(46, 165, 216, 1) 40%,
      rgba(37, 147, 200, 1) 50%,
      rgba(14, 99, 158, 1) 65%,
      rgba(0, 71, 134, 1) 75%,
      rgba(0, 71, 134, 1) 85%,
      rgba(46, 165, 216, 1) 100%
    ); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(
      to right,
      rgba(46, 165, 216, 1) 0%,
      rgba(0, 71, 134, 1) 15%,
      rgba(0, 71, 134, 1) 24%,
      rgba(46, 165, 216, 1) 40%,
      rgba(37, 147, 200, 1) 50%,
      rgba(14, 99, 158, 1) 65%,
      rgba(0, 71, 134, 1) 75%,
      rgba(0, 71, 134, 1) 85%,
      rgba(46, 165, 216, 1) 100%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#2ea5d8', endColorstr='#2ea5d8',GradientType=1 ); /* IE6-9 */
  }
  .mobile-menu-line-active-1 {
    background-color: #fff;
    margin: -1px;
    transform: rotate(45deg);
  }
  .mobile-menu-line-active-2 {
    opacity: 0;
    position: absolute;
    transform: translateX(50px);
  }
  .mobile-menu-line-active-3 {
    background-color: #fff;
    margin: -1px;
    transform: rotate(-45deg);
  }
  .mobile-menu {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    left: 0;
    padding: 90px 0;
    position: fixed;
    top: 0;
    width: 100%;
  }
  .mobile-menu-main-items {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
  }
  .mobile-menu-main-items > li {
    display: flex;
    flex-direction: column;
    /* flex-basis: 10%; */
    padding: 0 20px;
    position: relative;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .mobile-menu-main-items > li > span,
  .mobile-menu-home {
    align-items: center;
    border-top: 1px solid #e3edf8;
    cursor: pointer;
    display: inline-flex;
    height: 100%;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 2px;
    padding: 10px 0;
    position: relative;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
    width: 100%;
  }
  .mobile-menu-main-items > li > span::after {
    content: "I";
    font-family: "alcomet";
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .mobile-menu-main-items .mobile-menu-main-item-active {
    background-color: #4474a8;
  }
  .mobile-menu-main-items .mobile-menu-main-item-active > span {
    border-top-color: transparent;
    color: #fff;
    height: initial;
  }
  .mobile-menu-main-items .mobile-menu-main-item-active > span::after {
    transform: translateY(-50%) rotate(180deg);
  }
  .mobile-menu-sub-items {
    display: flex;
    flex-direction: column;
    /* overflow: auto; */
    /* padding: 0 20px 10px; */
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .mobile-menu-sub-items-active {
    /* display: flex;
    flex-direction: column;
    overflow: auto; */
  }
  .mobile-menu-sub-items > li {
    align-items: center;
    display: flex;
    height: 0;
    overflow: hidden;
    opacity: 0;
    padding-left: 20px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .mobile-menu-sub-items-active > li {
    height: 38px;
    opacity: 1;
  }
  .mobile-menu-sub-items-active > li:last-of-type {
    margin-bottom: 10px;
  }
  .mobile-menu-sub-link {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 2px;
    text-transform: uppercase;
  }
  .mobile-menu-footer {
    align-items: center;
    bottom: 0;
    display: flex;
    height: 90px;
    left: 0;
    padding: 0 20px;
    position: absolute;
  }
  .mobile-menu-footer-item {
    align-items: center;
    border-radius: 50%;
    border: 1px solid #004785;
    color: #004785;
    font-size: 18px;
    display: inline-flex;
    height: 40px;
    justify-content: center;
    margin-right: 8px;
    width: 40px;
  }
  /* .mobile-menu-toggle-transition */
  .mobile-menu-toggle-transition-enter-active,
  .mobile-menu-toggle-transition-leave-active,
  .mobile-menu-transition-enter-active,
  .mobile-menu-transition-leave-active {
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .mobile-menu-toggle-transition-leave-to,
  .mobile-menu-toggle-transition-enter {
    opacity: 0;
    transform: translateX(20px);
  }
  .mobile-menu-transition-leave-to,
  .mobile-menu-transition-enter {
    opacity: 0;
    transform: translateY(-100%);
  }
}
@media screen and (max-width: 600px) {
  .mobile-menu-sub-items-active > li {
    height: 30px;
  }
  .mobile-menu-main-items > li > span,
  .mobile-menu-home {
    padding: 10px 0;
  }
  .mobile-menu-main-items > li > span,
  .mobile-menu-sub-link,
  .mobile-menu-home {
    font-size: 14px;
  }
  .mobile-menu-main-items > li > span::after {
    font-size: 12px;
  }
}
@media screen and (max-width: 440px) {
  .logo img {
    width: 150px;
  }
  .mobile-search-toggle,
  .mobile-menu-toggle {
    height: 40px;
    width: 40px;
  }
  .mobile-search-toggle-inside,
  .mobile-menu-toggle-inside {
    height: 32px;
    width: 32px;
  }
  .mobile-search-toggle {
    margin-right: 5px;
  }
  .mobile-search-toggle-inside > span {
    font-size: 14px;
  }
  .mobile-menu-line {
    width: 14px;
  }
  .mobile-menu-footer-item {
    height: 35px;
    margin-right: 5px;
    width: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Nav.vue